import * as React from "react"
import * as R from "ramda"

import { Values } from "../services/translate"
import { useIntlNitro } from "../services/context"

type Props = {
  t: string
  defaultMessage?: string
  // defaulted
  values?: Values
  html?: boolean
  transform?: (value: string) => string
}

/**
 * @deprecated use `react-intl`'s `FormattedMessage` instead
 */
const Translate = ({ t, defaultMessage, values, html, transform = R.identity }: Props) => {
  const intl = useIntlNitro()
  return html ? (
    <span
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{
        __html: transform(
          intl.translate(t, values, {
            defaultMessage,
          }),
        ),
      }}
    />
  ) : (
    <>
      {transform(
        intl.translate(t, values, {
          defaultMessage,
        }),
      )}
    </>
  )
}

Translate.defaultProps = {
  values: {},
  html: false,
  transform: R.identity,
}

export default Translate
